import { useQuery } from '@apollo/client'
import getManagerUsers from './useManagerUser.queries'

export default function useManagerUser(fsUserName) {
  const { data, loading, error } = useQuery(getManagerUsers, {
    variables: { fsUserName },
  })
  return { data, loading, error }
}
